import { ArrowLeft } from 'lucide-react';
import { Button, EmptyState } from '@platform/design-system';
import { useTranslation } from '@platform/i18n';
import { Link } from '@tanstack/react-router';
import { DASHBOARD_DEFAULTS } from '../app/search-params.ts';

export const ForbiddenPage = () => {
  const { t } = useTranslation();
  return (
    <EmptyState
      title={t('shell.forbidden')}
      action={
        <Link to="/" search={DASHBOARD_DEFAULTS}>
          <Button icon={<ArrowLeft size={20} aria-hidden="true" className="flip-inline" />} variant="outline">
            {t('shell.backHome')}
          </Button>
        </Link>
      }
    />
  );
};
